const newYearScroll = {
    state: {
        data: ["default"]
    },
    mutations: {
        SET_NEWYEAR_SCROLL: (state, data) => {
            state.data = data;
        }
    },
    actions: {
        setNewYearScroll({
            commit
        }, arg) {
            commit('SET_NEWYEAR_SCROLL', arg)
        }
    }
}

export default newYearScroll;